/**
 * Handles modifications to search result navigation
 */
define(['jquery', 'c21/results', 'c21/Params', 'c21/track', 'c21/maps/Paginator', 'c21/ajax', 'jqueryuniform'], function ($, results, Params, track, Paginator, ajax) {
   "use strict";

   return function () {
      /**
       * Event fired when the user selects a different sort order
       */
      var self = this,

         m_jListContainer,
         m_jSortBy,
         m_jPageSelector,
         m_jRppSelector,
         m_map,

         SEARCH_TYPE = results.SEARCH_TYPE,

         getSearchType = function () {
            return results.getSearchType();
         },

         resetSearch = function () {
            m_jListContainer.html("");
         },

         onSortByChange = function () {
            var strSortOrder = $(this).val(),
               oParams;

            if (strSortOrder !== undefined) {
               oParams = new Params();
               oParams.setParam("o", strSortOrder);
               oParams.removeParam("s");

               results.doPortalResults(oParams.getParams(), 'searchView.Paginate');
            }
         },

         /**
          * When the "Search Nav" section is loaded
          */
         refreshNavigation = function () {
            results.onSearchListInitialized(function () {
               updateResultPins();
            });
         },

         getRecords = function () {
            return $("#listContainer .recordRow");
         },

         setPinsVisibleOnMap = function (aPinsInView) {
            var iSearchType = getSearchType();
            switch (iSearchType) {
            case SEARCH_TYPE.PROPERTY:
               m_map.setPropertiesInView(aPinsInView);
               break;

            case SEARCH_TYPE.OFFICE:
               m_map.setOfficesInView(aPinsInView);
               break;

            default:
               m_map.setAgentsInView(aPinsInView);
               break;
            }
         },

         updateResultPins = function () {
            var jRecords = getRecords(),
               aPinsInView = [];

            $.each(jRecords, function (i, el) {
               var jRecord = $(el),
                  jId = jRecord.find("input.recordId"),
                  strId = jId.val();

               aPinsInView.push(strId);
            });

            setPinsVisibleOnMap(aPinsInView);
         },

         initializePageNumbers = function () {
            $(".PagerFull .Page, .PagerFull .PageNext, .PagerFull .PagePrevious").on("click.searchnav", function () {
               var jPage = $(this),
                  iPage = jPage.data("page");

               results.setResultStart(iPage);
            });
         },

         onHashChange = function () {
            resetSearch();
            var params = new Params();
            results.doPortalResults(params.getParams(), 'searchView.AllSubView');
         },

         initializeRpp = function () {
            m_jRppSelector = $("#rppSelect");
            m_jRppSelector.change(function () {
               var strRpp = $(this).val(),
                  oParams;

               if (strRpp !== undefined) {
                  oParams = new Params();
                  oParams.setParam("r", strRpp);
                  oParams.removeParam("s");

                  results.doPortalResults(oParams.getParams(), 'searchView.Paginate');
               }
            });
            m_jRppSelector.val(m_jRppSelector.data("rpp"));
         },

         initializePageSelector = function () {
            m_jPageSelector = $("#pageSelector");
            m_jPageSelector.change(function () {
               var strPage = $(this).val(),
                  iPage = parseInt(strPage, 10);

               if (strPage !== undefined) {
                  results.setResultStart(iPage);
               }
            });

            var strMaxPage = m_jPageSelector.data("maxpage"),
               strCurrentPage = m_jPageSelector.data("currentpage");

            new Paginator(strMaxPage, strCurrentPage);

            // Grab the current page # from the pagination
            // buttons at the bottom of the page
            var strPage = $(".Page.PagerCurrentPage").html();
            m_jPageSelector.val(strPage);
         },

         initializeSortBy = function () {
            //m_jSortBy = $("#sortSelectOffice, #sortSelectProperty, #sortSelectAgent");
            m_jSortBy = $("#sortSelect");
            m_jSortBy.val(m_jSortBy.data("sort"));
            m_jSortBy.change(onSortByChange);
            m_jSortBy.uniform({
               selectClass: "selector smallSelector"
            });
         },

         initialize = function () {
            initializeSortBy();
            initializeRpp();
            initializePageSelector();
            initializePageNumbers();

            m_jPageSelector.add(m_jRppSelector).uniform({
               selectClass: 'selector smallSelector'
            });

            refreshNavigation();
         };

      self.updatePins = function () {
         if (m_map) {
            updateResultPins();
         }
      };

      /* Called whenever the HTML is put into place and the map is ready */
      self.setMap = function (map) {
         m_map = map;

         m_jListContainer = $("#listContainer");
         ajax.bindLoadEvent(m_jListContainer, initialize);

         $(window).on("hashchangenotset.nav", onHashChange);
         if (!results.isPageUsingInlineSearchList()) {
            onHashChange();
         }
      };
   };
});
